export default "<ion-list>\n  <ng-content></ng-content>\n</ion-list>";